var map = {
	"./assets/arrow.svg": 55102,
	"./assets/blackmores.jpeg": 75750,
	"./assets/bloodPressure.svg": 1521,
	"./assets/buy-arrow.svg": 30050,
	"./assets/calendar.svg": 63850,
	"./assets/category-icon.png": 89451,
	"./assets/category-icon.svg": 13861,
	"./assets/centrum-advance.jpeg": 21614,
	"./assets/close-icon.svg": 96014,
	"./assets/facialSkinAge.svg": 30036,
	"./assets/general-wellness.svg": 88700,
	"./assets/generalWellness.svg": 67988,
	"./assets/go-multi-vitamin.jpeg": 52612,
	"./assets/go-multi-vitamin.svg": 30004,
	"./assets/greenlife.jpeg": 62383,
	"./assets/guardian-fish-oil.jpeg": 84735,
	"./assets/guardian-logo.png": 65383,
	"./assets/guardian-multivitamin.jpeg": 46419,
	"./assets/guardian-vitamin-b-1.jpeg": 65500,
	"./assets/guardian-vitamin-b-2.jpeg": 53139,
	"./assets/heartRate.svg": 82396,
	"./assets/holistic-way.jpeg": 12898,
	"./assets/hrvSdnn.png": 4460,
	"./assets/hrvSdnn.svg": 14532,
	"./assets/ibi.png": 98448,
	"./assets/ibi.svg": 1618,
	"./assets/lightbulb.png": 44969,
	"./assets/lightbulb.svg": 61355,
	"./assets/location.svg": 92310,
	"./assets/panoptic.png": 79038,
	"./assets/panoptic.svg": 84525,
	"./assets/right-arrow.svg": 87882,
	"./assets/shaklee-b-complex.jpeg": 39697,
	"./assets/stress-top.svg": 53843,
	"./assets/stress.svg": 97416,
	"./assets/swisse.jpeg": 10303,
	"./assets/voost.jpeg": 10391,
	"./chart": 6979,
	"./chart.vue": 6979,
	"./email-page": 42818,
	"./email-page.vue": 42818,
	"./recommendation": 66813,
	"./recommendation.vue": 66813,
	"./report-pdf": 28301,
	"./report-pdf.vue": 28301,
	"./resizeObserver": 95863,
	"./resizeObserver.js": 95863,
	"./vitalRangeChecker": 39796,
	"./vitalRangeChecker.js": 39796,
	"./vitals": 75265,
	"./vitals-type": 28768,
	"./vitals-type.vue": 28768,
	"./vitals.vue": 75265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50666;